import qs from 'qs'

export const getRedirectLocation = () => {
  const url = window.location.href.split('?')
  const query = url[url.length - 1]
  const parsedQuery = qs.parse(query)
  const redirectLocation = parsedQuery['redirect_uri']

  return redirectLocation
}